module.exports = __webpack_public_path__ + "img/50.59fe4ea7.svg";